import * as React from "react";
import { useParams } from "react-router-dom";
import RolesHandleForm from "../../components/TechnicalManagement/Roles/RolesHandleForm";

export default function RolesHandling() {
  const { id } = useParams();
  return <RolesHandleForm id={id} />;
}
